import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';

const MWEGraph = ({ chartData }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const theme = useTheme();
  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const formattedData = chartData.map((item) => ({
    ...item,
    Generation: item.Generation,
    // Sunlight: item.Sunlight,
    month: item.month,
  }));

  return (
    <Box mt={3} sx={{ width: isMobile ? '100%' : '70%' }}>
      <BarChart
        dataset={formattedData}
        xAxis={[
          {
            scaleType: 'band',
            dataKey: 'month',
          },
        ]}
        series={[
          {
            dataKey: 'Generation',
            label: 'Generation (units)',
            color: theme.palette.primary.main,
            valueFormatter: (value) => numberWithCommas(value?.toFixed(1)),
          },
          // {
          //   dataKey: 'Sunlight',
          //   label: 'Sunlight (kWh/m²/day)',
          //   color: '#FBD300',
          //   valueFormatter: (value) => value?.toFixed(2),
          // },
        ]}
        height={300}
        yAxis={[
          {
            width: 80,
            valueFormatter: (value) => numberWithCommas(value?.toFixed(0)),
          },
        ]}
        sx={{
          '& .MuiChartsAxis-root.MuiChartsAxis-directionY .MuiChartsAxis-line':
            {
              display: 'none',
            },
          '& .MuiChartsAxis-root.MuiChartsAxis-directionY .MuiChartsAxis-tick':
            {
              display: 'none',
            },
          '& .MuiChartsAxis-root.MuiChartsAxis-directionY .MuiChartsAxis-tickLabel':
            {
              fontWeight: 600,
              fill: 'gray',
            },
          '& .MuiChartsAxis-root.MuiChartsAxis-directionX .MuiChartsAxis-tickLabel':
            {
              fontWeight: 600,
            },
        }}
        borderRadius={10}
      />
    </Box>
  );
};

export default MWEGraph;
